module.exports = __webpack_public_path__ + "static/climatisation5-af68867dc29aeb56a790cf3cb46092c6.jpg";